import { ThreadSnapshotCache } from "@rakazo/core";

export type { CachedThreadTarget } from "@rakazo/core";
export {
  preloadThreadSnapshots,
  threadCacheKey,
  threadCacheReplayCursor,
} from "@rakazo/core";

export const threadSnapshotCache = new ThreadSnapshotCache();
